import React from 'react';

import PropTypes from 'prop-types';

import AssetNode from '~/shared/components/AssetNode';
import FullWidthCarousel from '~/shared/components/FullWidthCarousel';

const BuilderAsset = ({
  type,
  autoPlay,
  container,
  mobileContainer,
  ...rest
}) => {
  if (!container && !mobileContainer) {
    return null;
  }

  return type === 'carousel' ? (
    <FullWidthCarousel
      containerDesktop={container}
      containerMobile={mobileContainer}
      autoPlay={autoPlay}
      {...rest}
    />
  ) : (
    <AssetNode
      container={container}
      mobileContainer={mobileContainer}
      {...rest}
    />
  );
};

BuilderAsset.propTypes = {
  autoPlay: PropTypes.bool,
  container: PropTypes.string,
  mobileContainer: PropTypes.string,
  type: PropTypes.string,
};

export default BuilderAsset;
